<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <div style="margin-top:80px;width: 800px;margin-left: 400px;margin-bottom: 100px;">
            <el-form >
                <el-form-item>
                    <span style="font-size: 22px;">官网纠错</span>
                </el-form-item>
                 <el-form-item label="栏目名称">
                            <el-input v-model="recovery.columnName"></el-input>
        
                        </el-form-item>
                        <el-form-item label="错误描述">
                            <el-input  type="textarea"
                                       :rows="2" v-model="recovery.errorDes"></el-input>
                        </el-form-item>
                        <el-form-item label="用户">
                            <el-input v-model="recovery.user"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="recovery.phone"></el-input>
                        </el-form-item>
                    </el-form>
            <el-button type="primary" @click="sendError()">确 定</el-button>
        </div>
        
        <v-footer></v-footer>

    
</div>
</template>

<script>
export default {
    data(){
        return{
            recovery:{
                    columnName:"",
                    errorDes:"",
                    user:"",
                    phone:""
                },
        }
    },
     methods: {
            sendError(){
                var obj={
                    columnName:"栏目名称",
                    errorDes:"错误描述",
                    user:"用户",
                    phone:'手机号'
                }
                let url = `${api}/api/errorRecovery/addErrorRecovery`
                for(var i in this.recovery){
                    if(this.recovery[i]==''){
                        this.$message.error(obj[i]+": 不能为空");
                        return;
                    }

                }
                this.common.http.post(url,this.recovery).then(v=>{
                    if(v.status<400){
                        this.$message.success("提交成功!")
                    }else {
                        this.$message.error("提交失败!")
                    };
                    this.recovery={
                        columnName:"",
                        errorDes:"",
                        user:""
                    };
                    this.dialogVisible = false
                }).catch(()=>{
                    this.$message.error("提交失败!");
                    this.recovery={
                        columnName:"",
                        errorDes:"",
                        user:"",
                        phone:""
                    };
                    this.dialogVisible = false
                })
            }}
}
</script>

<style lang="less" scoped>

</style>